/**
 * Defines reducers related to view and update of the user details
 * this reducer will be combined in the store/RootReducer.js
 */
import {
  SET_USERS_ERROR_MESSAGES, CLEAR_HELPER_TEXT_MESSAGES, CLEAR_ERROR_MESSAGE, UPDATE_PROFILE_DETAILS_SUCCESS,
  CLOSE_TOAST_MESSAGE, UPDATE_PROFILE_DETAILS_ERROR, GET_COUNTRIES_LIST_ERROR, GET_COUNTRIES_LIST_SUCCESS,
} from 'constants/ActionTypes';
import matchErrorCodesToFields from 'utils/matchErrorCodesToFields.util';
import { InitProfileErrorMessages, USER_PROFILE_ERROR_CODES } from 'constants/AppConstants';

const initState = {
  userErrorMessages: InitProfileErrorMessages,
  showToast: false,
  errorCode: '',
  errorToastMessage: '',
  severity: 'success',
  countryList: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case SET_USERS_ERROR_MESSAGES: {
      const { eventId, errorMsgs } = action;
      const stateErrorMessages = { ...state.userErrorMessages };
      stateErrorMessages[eventId] = errorMsgs;
      return { ...state, userErrorMessages: stateErrorMessages };
    }

    case CLEAR_HELPER_TEXT_MESSAGES: {
      return { ...state, userErrorMessages: InitProfileErrorMessages };
    }

    case CLEAR_ERROR_MESSAGE: {
      const { fieldId } = action;
      const errorMsgs = { ...state.userErrorMessages };
      errorMsgs[fieldId] = '';
      return { ...state, userErrorMessages: errorMsgs };
    }

    case UPDATE_PROFILE_DETAILS_ERROR: {
      const { error } = action;
      const field = matchErrorCodesToFields(error.errorCode, USER_PROFILE_ERROR_CODES);
      if (field) {
        const errorMsgs = { ...state.userErrorMessages };
        errorMsgs[field] = error.message;
        return { ...state, userErrorMessages: errorMsgs };
      }
      return {
        ...state, errorToastMessage: error.message, errorCode: error.errorCode.toString(), showToast: true, severity: 'error',
      };
    }

    case UPDATE_PROFILE_DETAILS_SUCCESS: {
      return { ...state, showToast: true, severity: 'success' };
    }

    case CLOSE_TOAST_MESSAGE: {
      return {
        ...state, showToast: false,
      };
    }

    case GET_COUNTRIES_LIST_SUCCESS: {
      const { countryList } = action;
      return { ...state, countryList };
    }

    case GET_COUNTRIES_LIST_ERROR: {
      const { error } = action;
      return {
        ...state, errorToastMessage: error.message, errorCode: error.errorCode, showToast: true, severity: 'error',
      };
    }

    default:
      return state;
  }
}
